<div class="header">
    <h2>{{ 'assessors.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="assessors-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (error() !== null) {
    <app-unavailable [message]="'users.error.unavailable' | translate" />
} @else if (loading()) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (user(); as user) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="entity-header">
            <div class="entity-avatar">
                <app-avatar [image]="user.avatarId | mediaSrc | async" [label]="user.firstName | initials: user.lastName" size="lg" />
            </div>
            <div class="entity-identity">
                <h1>{{ user.firstName }} {{ user.lastName }}</h1>
                <span class="subtitle">{{ user.email }}</span>
            </div>
        </div>

        <p-message severity="info">{{ 'assessors.modal.edit.info' | translate }}</p-message>

        <div class="section">
            <h2>{{ 'assessors.fieldset.scope' | translate }}</h2>
            <app-form-multiselect
                [control]="form.controls.organisationIds"
                [label]="'assessors.form.organisations' | translate"
                [placeholder]="'assessors.form.organisations.placeholder' | translate"
                [options]="organisationOptions()"
                [filter]="true"
                [showToggleAll]="false"
                inputId="organisationIds"
                testId="assessors-edit-organisation-ids"
            />
            <app-form-multiselect
                [control]="form.controls.schoolIds"
                [label]="'assessors.form.schools' | translate"
                [placeholder]="'assessors.form.schools.placeholder' | translate"
                [options]="schoolOptions()"
                [filter]="true"
                [loading]="schoolsLoading()"
                inputId="schoolIds"
                testId="assessors-edit-school-ids"
            />
        </div>

        <div class="section">
            <h2>{{ 'assessors.fieldset.content' | translate }}</h2>
            <app-form-multiselect
                [control]="form.controls.courseIds"
                [label]="'assessors.form.courses' | translate"
                [placeholder]="'assessors.form.courses.placeholder' | translate"
                [options]="courseOptions()"
                [filter]="true"
                [loading]="coursesLoading()"
                inputId="courseIds"
                testId="assessors-edit-course-ids"
            />
            <app-form-multiselect
                [control]="form.controls.packageIds"
                [label]="'assessors.form.packages' | translate"
                [placeholder]="'assessors.form.packages.placeholder' | translate"
                [options]="packageOptions()"
                [filter]="true"
                [loading]="packagesLoading()"
                inputId="packageIds"
                testId="assessors-edit-package-ids"
            />
        </div>
    </form>

    <div class="footer">
        <p-button
            [label]="'assessors.form.cancel' | translate"
            [disabled]="saving()"
            [outlined]="true"
            severity="secondary"
            data-test="assessors-edit-cancel"
            (onClick)="close()"
        />
        <p-button type="submit" [label]="'assessors.form.save' | translate" [disabled]="saving()" data-test="assessors-edit-save" (onClick)="onSubmit()" />
    </div>
}
